import React, { ReactNode } from 'react';
import LoadingProvider from './LoadingProvider';
import SessionExpiredModalProvider from './SessionExpiredModalProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadingProvider>
        <SessionExpiredModalProvider>{children}</SessionExpiredModalProvider>
      </LoadingProvider>
    </QueryClientProvider>
  );
};

export default Providers;
